import { lazy } from "react";
import { Outlet } from "react-router-dom";
// CUSTOM COMPONENTS
import Loadable from "./Loadable";
import MainLayout from "layouts/main/MainLayout";

// const Home = Loadable(lazy(() => import("pages/home")));

// ROLE BASED PERMISSION TEST PAGE
const Permission = Loadable(lazy(() => import("pages/permission")));

// FEATURES RELATED PAGES
const Faqs = Loadable(lazy(() => import("pages/faq")));
const Pricing = Loadable(lazy(() => import("pages/pricing")));
const ContactUs = Loadable(lazy(() => import("pages/contact-us")));
const ComingSoon = Loadable(lazy(() => import("pages/coming-soon")));
const Maintenance = Loadable(lazy(() => import("pages/maintenance")));
const Career = Loadable(lazy(() => import("pages/career/career")));
const AboutUs = Loadable(lazy(() => import("pages/about-us/about-us")));
export const PublicRoutes = [
// { path: "home", element: <Home /> },
{
  path: "permission",
  element: <Permission />
}, {
  path: "maintenance",
  element: <Maintenance />
}, {
  element: <MainLayout>
        <Outlet />
      </MainLayout>,
  children: [{
    path: "about-us",
    element: <AboutUs />
  }, {
    path: "contact-us",
    element: <ContactUs />
  }, {
    path: "faqs",
    element: <Faqs />
  }, {
    path: "pricing",
    element: <Pricing />
  }, {
    path: "career",
    element: <Career />
  }, {
    path: "coming-soon",
    element: <ComingSoon />
  }]
}];